import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  Dialog,
  InputGroup,
  Tabs, Tab,
} from '@blueprintjs/core';
import {Translate, I18n} from 'react-redux-i18n';

import {
  closePreviewDialog,
  closePreviewSingleDialog,
} from './ExerciseBenchmarkActions';
import {
  sendMessage,
} from '../ExerciseRun/CommunicationBoxActions'
import style from './PreviewDialog.module.css';

class PreviewBenchmarkDialog extends Component {
  
  constructor(props) {
    super(props);
    
    this.state = {
      answers: [],
      notes: [],
    }
  }
  
  componentDidUpdate(prevProps) {
    if(this.props.currentSingleBenchmark !== prevProps.currentSingleBenchmark) {
      this.setState({ 
        answers: (new Array(Number(!!this.props.currentSingleBenchmark))).fill([]),
      })
    }
  }
  
  handleAnswer = (cIndex, index, aIndex) => {
    if(this.props.answerable) {
      this.setState((prevState)=>{
        const updatedAnswers = prevState.answers;
        updatedAnswers[cIndex] = updatedAnswers[cIndex] || [];
        updatedAnswers[cIndex][index] = aIndex;
        return { answers: updatedAnswers };
      })
    }
  }
  
  render() {
    const benchmark = this.props.currentSingleBenchmark;
    const cIndex = 0;
    return (
      <Dialog
        autoFocus={true}
        canEscapeKeyClose={true}
        canOutsideClickClose={true}
        enforceFocus={true}
        isOpen={this.props.isPreviewSingleBenchmarkDialogOpen}
        usePortal= {true}
        onClose={this.props.closePreviewSingleDialog}
        title={<span style={{color: 'white'}}>{this.props.answerable? <Translate value="exercise.Benchmark" /> : <Translate value="exercise.PreviewBenchmark" />}</span>}
        style={{width: '70%', background: 'white'}}
      >
        {
          !!benchmark &&
            <div className={`column centered`}>
              <div className={`column centered ${style.mainContainer} col-sm-8`}>
                <h4>{benchmark.name.toUpperCase()}</h4>
                <table className={`${style.qtable}`}>
                  <tbody>
                  {
                    benchmark.questions.map((question, index) => (
                      <tr key={"q-"+index}>
                        <td>
                          <span className={`${style.questionCount}`}>{index + 1}.</span>{question.title}  
                        </td>
                        <td>
                          <React.Fragment>
                            {
                              question.answers.map((answer, aIndex) => (
                                <span
                                  className={`${style.answer} ${this.props.answerable? "pointer" : ""} ${(this.state.answers[cIndex] && (this.state.answers[cIndex][index] === aIndex))? style.highlightedAnswer : ""}`}
                                  onClick={()=>this.handleAnswer(cIndex, index, aIndex)}
                                  key={"q-"+index+"-a-"+aIndex}
                                >
                                  {answer}
                                </span>
                              ))
                            }
                          </React.Fragment>
                        </td>
                        {
                          this.props.answerable &&
                          <td>
                            <input
                              value={this.state.notes[index]}
                              onChange={(event)=>{
                                event.persist();
                                this.setState((prevState)=>{
                                  prevState.notes[index] = event.target.value;
                                  return {notes: prevState.notes};
                                })
                              }}
                              onKeyUp={(event) => {
                                if(event.key === "Enter") {
                                  this.handleAnswer(cIndex, index, this.state.answers[cIndex][index]);
                                }
                              }}
                              maxLength={200}
                            />
                          </td>
                        }
                      </tr> 
                    ))
                  }
                  </tbody>
                </table>
              </div>
            <div className="row" style={{marginTop: 10}}>
              <button
                className={`btn btn-primary ${style.closeBtn}`} 
                onClick={()=>{
                  window.open(`/print-evaluation?state=${encodeURIComponent(JSON.stringify({answers: [], notes: [], benchmarks: [this.props.currentSingleBenchmark], exerciseName: this.props.exercise?.name, exerciseCode: this.props.exercise?.code}))}`, "_blank");
                }}
              >
                <Translate value="controls.Print" />
              </button>
              <button className={`btn btn-primary ${style.closeBtn}`} style={{marginLeft: 3}} onClick={this.props.closePreviewSingleDialog}><Translate value="controls.Close" /></button>
            </div>
          </div>
        }
      </Dialog>
    )
  }
}

const mapStateToProps = (state) => ({
  benchmark: state.exercise.benchmark,
  currentSingleBenchmark: state.exerciseBenchmark.currentSingleBenchmark,
  isPreviewSingleBenchmarkDialogOpen: state.exerciseBenchmark.isPreviewSingleBenchmarkDialogOpen,
  exercise: state.exercise.exercise,
});

const mapDispatchToProps = ({
  closePreviewDialog,
  closePreviewSingleDialog,
  sendMessage
})

export default connect(mapStateToProps, mapDispatchToProps)(PreviewBenchmarkDialog);